
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
Group,
GroupTitle,
Cell
},
created() {
console.log('created...')
this.initOrderInfo()
this.initShopInfo()
},
methods:{
initOrderInfo(){
let shopId = this.shopId
let _this = this;
console.log(_this.$router.currentRoute.params.id)
_this.axios.get('/v1/shop/'+shopId+'/order/' + _this.$router.currentRoute.params.id, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {
_this.orderDetail = formateOrder(response.data.data)
}

}).catch(function (response) {
console.log(response);
});
},
initShopInfo(){
let shopId = this.shopId
let _this = this;
let uri = '/v1/shop/'+ shopId;
let params = null;
_this.axios.get(uri, params, {
headers: {}
}).then(function (response) {
if (response.data.code == 0) {

_this.shopName = response.data.data.name
} else {

console.log('处理错误提醒');
}
}).catch(function (response) {
console.log(response);

});
}
},
data () {
return {
shopName: '',
orderDetail: {},
shopId: this.$route.params.shopId
}
}
}

function formateOrder(data) {
let rs = {
orderNo: data.order_no,
goodsName: data.goods_name,
goodsNum: data.quantity,
checkInTime: data.check_in_date,
checkInWeek: data.check_in_week,
checkOutTime: data.check_out_date,
checkOutWeek: data.check_out_week,
nights: data.nights, // 住了几晚
price: data.price,
totalPrice: data.total_price,
realPrice: data.real_price != null ? data.real_price*0.01 : null,
contact: data.guest_names,
sourceName: data.source_name,
createTime: data.created_at,
statusName: data.status_desc,
mobile: data.mobile_no
}
return rs
}



// WEBPACK FOOTER //
// ./src/components/order/Detail.vue